import { TeamSegmentTypeEnum, TeamTypeEnum } from '@kudos/http-client'
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import { t } from '@transifex/native'

export const getTeamIcon = (teamType: TeamTypeEnum) => {
  switch (teamType) {
    case TeamTypeEnum.MANUAL:
      return <GroupsOutlinedIcon />
    case TeamTypeEnum.AUTOMATED:
      return <SyncOutlinedIcon />
    case TeamTypeEnum.QUICK:
      return <BoltOutlinedIcon />
  }
}

export const generateTeamName = (name: string, segmentType: TeamSegmentTypeEnum | null = null) => {
  if (segmentType) {
    switch (segmentType) {
      case TeamSegmentTypeEnum.COUNTRY:
        return t('Country: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.REGION:
        return t('Region: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.LOCATION:
        return t('Location: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.DEPARTMENT:
        return t('Department: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.COST_CENTER:
        return t('Cost center: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.BUSINESS_UNIT:
        return t('Business unit: {teamName}', { teamName: name })
      case TeamSegmentTypeEnum.GROUP:
        return t('Group: {teamName}', { teamName: name })
    }
  }
  return name
}
